import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchClientes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('clientes', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchCredor(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`clientes/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addCliente(ctx, clienteData) {
      return new Promise((resolve, reject) => {
        axios
          .post('clientes', clienteData )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
